
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Methodik`}</h1>
    <p>{`Für die Berechnung der Alkoholmenge dient die `}<a parentName="p" {...{
        "href": "http://www.alcohol-facts.ch/de/das-standardglas-alkohol"
      }}>{`Angabe über die Alkoholmenge in Getränken vom BAG`}</a>{`. In der Alkoholforschung wird die getrunkene Menge Alkohol meist in Gramm reinen Alkohols angegeben, während vor allem in der Prävention oft auch von den sogenannten Standardgläsern gesprochen wird. Unter einem Standardglas versteht man die normalerweise in einem Restaurant ausgeschenkte Alkoholmenge. Also eine Stange Bier, ein Glas Wein oder ein Gläschen Schnaps. Ein Standardglas Alkohol enthält in der Regel zwischen 10 und 12g reinen Alkohol.`}</p>
    <p>{`Die Daten zum länder- und geschlechtsspezifischen Alkoholkonsum stammen von der WHO (`}<a parentName="p" {...{
        "href": "http://apps.who.int/gho/data/node.main.A1036"
      }}>{`Alkoholkonsum nach Geschlecht`}</a>{`, `}<a parentName="p" {...{
        "href": "http://apps.who.int/gho/data/node.main.A1023"
      }}>{`Alkoholkonsum nach Getränketyp`}</a>{`). Der Alkoholkonsum nach Geschlecht berücksichtigt alle Einwohner, die älter als 15 Jahre sind. Weltweit unterscheidet sich der Alkoholkonsum zwischen Männern und Frauen enorm.`}</p>
    <p>{`Alle Angaben zum Alkoholverhalten in der Schweiz stammen aus der Auswertung der Befragung Suchtmonitoring Schweiz 2011–2016, BAG / Sucht Schweiz.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;